import React from "react";
import { Formik, Form, Field, getIn, ErrorMessage } from "formik";
import * as Yup from "yup";
import { merge as mergeObjects } from "lodash";

import ErrorLine from "../elements/ErrorLine";

function FormTextsImprint(props) {
  const validation = Yup.object().shape({
    client: Yup.object().shape({
      name: Yup.string().required("Bitte geben Sie einen Namen ein."),
      address: Yup.string().required("Bitte geben Sie Straße und Hausnummer ein."),
      zip: Yup.number().required("Bitte geben Sie eine PLZ ein."),
      city: Yup.string().required("Bitte geben Sie einen Ort ein."),
      contact_person: Yup.object().shape({
        email: Yup.string().email("Keine gültige E-Mail-Adresse").required("Bitte geben Sie eine E-Mail-Adresse ein.")
      })
    })
  });

  const defaultValues = {
    client: {
      name: "",
      address: "",
      zip: "",
      city: "",
      website: "",
      contact_person: {
        email: "",
        tel: ""
      }
    },
    additional: ""
  };

  const onSubmit = async (values, { resetForm, setSubmitting }) => {
    let payload = { ...values };
    try {
      const response = await props.onSubmit("imprint", payload);
      if (response.success) resetForm({ values: response.data });
      else console.log("Form send unsuccessful");
    } catch (error) {
      console.log("Error:", error);
    }
    setSubmitting(false);
  };

  return (
    <Formik initialValues={mergeObjects(defaultValues, props.data)} validationSchema={validation} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting }) => (
        <Form autoComplete="on">
          {/* <h2 className="title is-4">Impressum</h2> */}
          <h2 className="title is-5">Mandant</h2>
          <div className="field">
            <label className="label">Name*</label>
            <div className="control">
              <Field name="client.name" type="text" className={`input${getIn(touched, "client.name") && getIn(errors, "client.name") ? " is-danger" : ""}`} />
            </div>
            <ErrorMessage component={ErrorLine} name="client.name" />
          </div>
          <div className="field">
            <label className="label">Straße und Hausnummer*</label>
            <div className="control">
              <Field name="client.address" type="text" className={`input${getIn(touched, "client.address") && getIn(errors, "client.address") ? " is-danger" : ""}`} />
            </div>
            <ErrorMessage component={ErrorLine} name="client.address" />
          </div>
          <div className="field field-body">
            <div className="field">
              <label className="label">PLZ*</label>
              <div className="control">
                <Field name="client.zip" type="number" className={`input${getIn(touched, "client.zip") && getIn(errors, "client.zip") ? " is-danger" : ""}`} />
              </div>
              <ErrorMessage component={ErrorLine} name="client.zip" />
            </div>
            <div className="field">
              <label className="label">Ort*</label>
              <div className="control">
                <Field name="client.city" type="text" className={`input${getIn(touched, "client.city") && getIn(errors, "client.city") ? " is-danger" : ""}`} />
              </div>
              <ErrorMessage component={ErrorLine} name="client.city" />
            </div>
          </div>
          <div className="field">
            <label className="label">Website</label>
            <div className="control">
              <Field name="client.website" type="text" className={`input`} />
            </div>
          </div>
          <div className="field">
            <label className="label">E-Mail-Adresse*</label>
            <p className="control has-icons-left">
              <Field name="client.contact_person.email" type="email" className={`input${getIn(touched, "client.contact_person.email") && getIn(errors, "client.contact_person.email") ? " is-danger" : ""}`} />
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
            </p>
            <ErrorMessage component={ErrorLine} name="client.contact_person.email" />
          </div>
          <div className="field">
            <label className="label">Telefonnummer</label>
            <div className="control has-icons-left">
              <Field name="client.contact_person.tel" type="tel" className={`input`} />
              <span className="icon is-small is-left">
                <i className="fas fa-phone-alt"></i>
              </span>
            </div>
          </div>

          <h2 className="title is-5">Zusatzangaben (z.B. Registrierung, Vertretungsberechtigte, usw.)</h2>

          <div className="field">
            <div className="control">
              <Field component="textarea" rows={4} name="additional" className={`textarea`} />
            </div>
          </div>

          <hr />

          <div className="field">
            <div className="control field-body">
              <button className="button is-success" type="submit" disabled={isSubmitting}>
                Speichern
              </button>
              <button className="button ml-2" type="button" onClick={props.onCancel}>
                Abbrechen
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}
export default FormTextsImprint;
